import { OPEN_RACE_BTN_BORDER } from 'assets/images'
import styled from 'styled-components'

const RequestLoginModalStyled = styled.div`
  .request-login-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 32px;

    min-width: 450px;
    min-height: 280px;

    .login-container {

      .login-wrapper {
        gap: 16px;

        .login-btn {
          border: none;
          opacity: 0.8;
          background: transparent;
          cursor: pointer;

          &:hover {
            opacity: 1;
          }

          &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
          }

          .login-img {
            max-width: 200px;
            width: 100%;

            &:hover {
              box-shadow: 0px 0 10px #f5cc00, 0 0 5px #f5cc00, 0 0 14px #2196f3;
            }
          }
        }
      }
    }

    .err-container {
      margin-top: 12px;
    }

    .btn-container {
      .cancel-btn {
        background-color: ${({ theme }) => theme.color.transparent};
        background-image: url(${OPEN_RACE_BTN_BORDER});
        background-repeat: no-repeat;
        background-size: contain;
        border: none;

        width: 110px;
        aspect-ratio: 110 / 34;
        font-size: 16px;
        cursor: pointer;

        ${({ theme }) => theme.media.lessThan(theme.size.xl)} {
          width: 90px;
          font-size: 12px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          width: 110px;
          font-size: 16px;
        }

        ${({ theme }) => theme.media.lessThan(theme.size.lg)} {
          width: 140px;
        }
      }
    }
  }
`

export default RequestLoginModalStyled
